import { useEffect, useState } from 'react';

const defaultDelayMs = 120;

const scheduleIdleTask = (callback: () => void) => {
  let timeoutId: ReturnType<typeof globalThis.setTimeout> | undefined;
  let idleCallbackId: number | undefined;

  const animationFrameId = requestAnimationFrame(() => {
    timeoutId = globalThis.setTimeout(() => {
      if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
        idleCallbackId = window.requestIdleCallback(callback, { timeout: 500 });
        return;
      }

      callback();
    }, defaultDelayMs);
  });

  return () => {
    if (animationFrameId !== undefined) {
      cancelAnimationFrame(animationFrameId);
    }

    if (timeoutId !== undefined) {
      globalThis.clearTimeout(timeoutId);
    }

    if (
      idleCallbackId !== undefined &&
      typeof window !== 'undefined' &&
      'cancelIdleCallback' in window
    ) {
      window.cancelIdleCallback(idleCallbackId);
    }
  }
};

export const useDeferredSectionCount = (sectionCount: number) => {
  const [visibleSectionCount, setVisibleSectionCount] = useState(0);

  useEffect(() => {
    setVisibleSectionCount(0);
  }, [sectionCount]);

  useEffect(() => {
    if (visibleSectionCount >= sectionCount) {
      return;
    }

    const cancelTask = scheduleIdleTask(() => {
      setVisibleSectionCount(currentCount => Math.min(currentCount + 1, sectionCount));
    });

    return cancelTask;
  }, [sectionCount, visibleSectionCount]);

  return visibleSectionCount;
};
